import { lazy, Suspense } from 'react';

const LazyPolicy = lazy(() => import('./Policy'));

const Policy = () => (
  <Suspense fallback={null}>
    <LazyPolicy />
  </Suspense>
);

export default Policy;
